module.exports = __webpack_public_path__ + "static/Futura-Bold-d7252a47fae84ded128df9373e2bf573.otf";